import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  Input,
  NgZone,
  OnInit,
} from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Component({
  selector: 'app-accordion-header',
  templateUrl: './accordion-header.component.html',
  styleUrls: ['./accordion-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccordionHeaderComponent implements OnInit {
  toggleClickEmitter = new Subject();
  collapsed$ = new BehaviorSubject<boolean>(false);

  collapseOnHeaderClick$ = new BehaviorSubject<boolean>(false);
  @Input() set collapseOnHeaderClick(value: boolean) {
    this.collapseOnHeaderClick$.next(value);
  }
  get collapseOnHeaderClick() {
    return this.collapseOnHeaderClick$.value;
  }

  displayArrowButton$ = new BehaviorSubject<boolean>(true);
  @Input() set displayArrowButton(value: boolean) {
    this.displayArrowButton$.next(value);
  }
  get displayArrowButton() {
    return this.displayArrowButton$.value;
  }

  newCollapseButton$ = new BehaviorSubject<boolean>(false);
  @Input() set newCollapseButton(value: boolean) {
    this.newCollapseButton$.next(value);
  }
  get newCollapseButton() {
    return this.newCollapseButton$.value;
  }

  @HostListener('click') onClick() {
    if (this.collapseOnHeaderClick) {
      this.ngZone.run(() => {
        this.toggleClickEmitter.next(null);
      });
    }
  }

  constructor(private ngZone: NgZone) {}

  ngOnInit(): void {}

  toggleClick(): void {
    if (!this.collapseOnHeaderClick) {
      this.toggleClickEmitter.next(null);
    }
  }

  setCollapsedState(collapsed: boolean): void {
    this.collapsed$.next(collapsed);
  }
}
